import { getAuth, Auth } from 'firebase/auth';
import { useFirebaseApp } from './useFirebaseApp';
import { useMemo } from 'react';

export const useFirebaseAuth = (): Auth => {
  const firebaseApp = useFirebaseApp();
  return useMemo(() => getAuth(firebaseApp), [firebaseApp]);
};
